import axios from 'axios';
import Vue from 'vue'

export default {

    sendContactUsMail (ContactUs) {
        return axios.post('/api/contact/contact-us', ContactUs)
        .then(response => {
            if (response && response.data) 
                {
                    Vue.prototype.$snotify.success('Message envoyé avec succès');
                    return response.data

                }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
}

